<template>
  <div>
    <el-tabs v-model="qdtab" style="margin-right: 40px;margin-left: 40px;">
      <el-tab-pane label="已预约记录" name="readyyy">
        <el-row class="querypanel">
          <el-col :span="24">
            <el-form ref="form"  label-width="100px" label-position="left" >
              <el-form-item label="排课日期">
                <el-date-picker
                  v-model="pkdate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-form ref="form"  label-width="100px" label-position="left" >
              <el-form-item label="用户手机号">
                <el-input  v-model="ed_userphone" placeholder="请选择预约的用户"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button @click="query_cp">查找排课表</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_cp"
            ref="multipleTable">
            <el-table-column
              prop="plandate.String"
              width="180px"
              label="预约日期">
            </el-table-column>
            <el-table-column
              prop="userphone.String"
              width="180px"
              label="预约手机">
            </el-table-column>
            <el-table-column
              prop="usernick.String"
              width="180px"
              label="预约姓名">
            </el-table-column>
            <el-table-column
              prop="teachername.String"
              label="讲师">
            </el-table-column>
            <el-table-column
              prop="cname.String"
              label="班级信息">
            </el-table-column>
            <el-table-column
              prop="ctitle.String"
              label="课程信息">
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="30px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="删除班级" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_cp(scope.$index, data_cp)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="开始预约" name="startyy">
        <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
          <el-row>
            <el-col :span="12">
              <el-form-item label="预约用户">
                <el-input  v-model="ed_ts_member" placeholder="请选择预约的用户">
                  <el-button slot="append" icon="el-icon-search" @click="ev_sel_user"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="预约日期">
            <el-date-picker
              v-model="tscheduledate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择班级">
                <el-input  v-model="ed_ts_class" placeholder="请选择目前跟的班级（非必选）">
                  <el-button slot="append" icon="el-icon-search" @click="ev_sel_class"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择讲师">
                <el-input  v-model="ed_ts_teacher" placeholder="请选择负责的讲师">
                  <el-button slot="append" icon="el-icon-search" @click="ev_sel_teacher"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择课程">
                <el-input  v-model="ed_ts_course" placeholder="请选择预约的课程">
                  <el-button slot="append" icon="el-icon-search" @click="ev_sel_course"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="slipline"></div>
        <el-button class="gibasebtn" style="margin-left: 20px" @click="save_cp">开始预约</el-button>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="讲师选择" :visible.sync="vis_sel_teacher">
      <el-table
        fit
        :data="data_teacher"
        highlight-current-row
        @current-change="sel_teacher_change"
        ref="multipleTable">
        <el-table-column
          prop="id.Int64"
          label="讲师编号">
        </el-table-column>
        <el-table-column
          prop="name.String"
          width="180px"
          label="讲师名">
        </el-table-column>
        <el-table-column
          label="头像">
          <template slot-scope="scope">
            <div v-if="scope.row.portrait.Valid">
              <img :src="scope.row.portrait.String" class="avatarimg3">
            </div>
            <div v-else>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone.String"
          label="联系方式">
        </el-table-column>
        <el-table-column
          prop="addtime.String"
          label="添加时间">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="班级选择" :visible.sync="vis_sel_class">
      <el-table
        fit
        :data="data_class"
        highlight-current-row
        @current-change="sel_class_change"
        ref="multipleTable">
        <el-table-column
          prop="id.Int64"
          label="班级编号">
        </el-table-column>
        <el-table-column
          prop="cname.String"
          width="180px"
          label="班级名">
        </el-table-column>
        <el-table-column
          prop="ctype"
          label="类别ID">
        </el-table-column>
        <el-table-column
          prop="teacherlist.String"
          label="讲师ID列表">
        </el-table-column>
        <el-table-column
          prop="courselist.String"
          label="课程ID列表">
        </el-table-column>
        <el-table-column
          prop="agearea.String"
          label="适合年龄段">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="课程选择" :visible.sync="vis_sel_course">
      <el-table
        fit
        :data="data_course"
        highlight-current-row
        @current-change="sel_course_change"
        ref="multipleTable">
        <el-table-column
          prop="id.Int64"
          label="课程编号">
        </el-table-column>
        <el-table-column
          prop="ctitle.String"
          width="180px"
          label="课程名称">
        </el-table-column>
        <el-table-column
          prop="csubtitle.String"
          label="课程子标题">
        </el-table-column>
        <el-table-column
          prop="addtime.String"
          label="添加时间">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="用户选择" :visible.sync="vis_sel_member">
      <el-table
        stripe
        :data="data_member"
        highlight-current-row
        @current-change="sel_member_change"
        ref="multipleTable">
        <el-table-column
          prop="usernick.String"
          width = "200px"
          label="会员昵称">
        </el-table-column>
        <el-table-column
          label="头像">
          <template slot-scope="scope">
            <div v-if="scope.row.userimg.Valid && scope.row.userimg.String !== ''">
              <img :src="scope.row.userimg.String" class="avatarimg">
            </div>
            <div v-else>
              {{scope.row.userimg.String}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone.String"
          label="电话号码">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'CoursePlan',
  beforeCreate: function () {
    that = this
    console.log('开始创建')
  },
  data () {
    return {
      qdtab: 'readyyy',
      tscheduledate: '',
      khid: '',
      data_cp: [],
      pkdate: '',
      ed_course_teacherlist: [],
      ed_ts_teacher: '',
      ed_ts_class: '',
      ed_ts_course: '',
      ed_ts_member: '',
      vis_sel_teacher: false,
      vis_sel_class: false,
      vis_sel_course: false,
      vis_sel_member: false,
      data_teacher: [],
      data_class: [],
      data_course: [],
      data_member: [],
      sel_teacher: '',
      sel_class: '',
      sel_course: '',
      sel_member: '',
      ed_userphone: ''
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
    }
  },
  methods: {
    query_cp () {
      var qstr = 'cusid =' + that.khid
      if (that.ed_userphone !== null && that.ed_userphone !== '') {
        qstr = qstr + " and userphone like '%" + that.ed_userphone + "%' "
      }
      if (this.pkdate !== null && this.pkdate !== '') {
        qstr = qstr + " and plandate >= '" + this.pkdate[0] + "' and plandate<='" + this.pkdate[1] + "'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qbcp',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取班级数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_cp = JSON.parse(res.data.data)
            console.log(that.data_cp)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    del_cp: function (index, data) {
      console.log(data[index])
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/dbcp',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryteacher () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/qti',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sortinfo: {String: ' order by addtime desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取讲师数据')
            localStorage.setItem('teacherinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_teacher = JSON.parse(res.data.data)
            that.ed_course_teacherlist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryclass () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/qbci',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取班级数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_class = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querycourse () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qci',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by addtime desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取产品数据')
            localStorage.setItem('courseinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_course = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querymember () {
      var qstr = ' usernick is not null '
      that.$http({
        url: 'https://api.sqnetsoft.cn/member/gbmu',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.data_member = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    sel_teacher_change (val) {
      this.sel_teacher = val
      console.log(this.sel_teacher)
      this.vis_sel_teacher = false
      this.ed_ts_teacher = this.sel_teacher.name.String
    },
    sel_class_change (val) {
      this.sel_class = val
      console.log(this.sel_class)
      this.vis_sel_class = false
      this.ed_ts_class = this.sel_class.cname.String
    },
    sel_course_change (val) {
      this.sel_course = val
      console.log(this.sel_course)
      this.vis_sel_course = false
      this.ed_ts_course = this.sel_course.ctitle.String
    },
    sel_member_change (val) {
      this.sel_member = val
      console.log(this.sel_member)
      this.vis_sel_member = false
      this.ed_ts_member = this.sel_member.phone.String
    },
    ev_sel_teacher () {
      this.vis_sel_teacher = true
      that.$options.methods.queryteacher()
    },
    ev_sel_class () {
      this.vis_sel_class = true
      that.$options.methods.queryclass()
    },
    ev_sel_course () {
      this.vis_sel_course = true
      that.$options.methods.querycourse()
    },
    ev_sel_user () {
      this.vis_sel_member = true
      that.$options.methods.querymember()
    },
    save_cp () {
      console.log(this.tscheduledate)
      var tmpdata = new Date(this.tscheduledate)
      var week = tmpdata.getDay()
      console.log(week)
      var adddata = {
        userphone: {String: this.ed_ts_member, Valid: true},
        plandate: {String: this.tscheduledate, Valid: true},
        weekid: parseInt(week),
        classid: parseInt(this.sel_class.id.Int64),
        courseid: parseInt(this.sel_course.id.Int64),
        teacherid: parseInt(this.sel_teacher.id.Int64),
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aaubcp',
        method: 'post',
        data: adddata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '排课完毕!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/course/CoursePlan.vue